import { React, useEffect, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {  handleUserLevelAccessPermissions, getFormattedDate,changeDateFormat,isEndDateGreater} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import titlesData from '../../../../titles.json';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {generateAnimalProductInputReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

const AnimalProductInputReport = () => {
  const token = useContext(MyContextProvider).token;
  const decode_token = jwtDecode(token);
  const [isDivision, setIsDivision] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [buttonAccess, setButtonAccess] = useState(false);
  const storedLanguage = localStorage.getItem('language');
  const today = new Date();
  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
  };



  useEffect(() => {
   const level = handleUserLevelAccessPermissions(decode_token);
    setButtonAccess(level)
    if (level.userLevel === "DIVISION LEVEL" && level.roles.includes("DIVADM")) {
        setIsDivision(true);
    }
}, []);



//handle excel sheet ***************
const handleGenerateExcel = () => {
  if (!startDate || !endDate) {
    toast.error('Please select the date range', messages.COLOR_RED);
    return;
  }
      
 if(!isEndDateGreater(startDate,endDate)){
    toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
    return;
  }

  if (endDate <= startDate) {
    toast.error('End date cannot be earlier than start date', messages.COLOR_RED);
    return;
  }

   showLoading(true);
   let sDate= getFormattedDate(startDate)
   let eDate= getFormattedDate(endDate)
  const payload = {
      fromDate: sDate,
      toDate: eDate,
  };

    // POST request to API
    axios
      .post(`${API_URL}api/price/animalreport`, payload, config)
      .then((response) => {
 
        // Handle success and generate the Excel file directly
        const generalMiningReportData = response.data.data.groupCodes;
       let excelFileName = `PriWholesaleAnimalInputReport_${payload.fromDate}-${payload.toDate})`;
        const excelObjectData = {
          fileName: excelFileName,
          reportType: excelFileName,
          fileType: 'xls',
          sheetName: 'Wholesale Animal Input Report',
          firstRowMergeCells: "A1:G1",
          firstRowExportDate: changeDateFormat(new Date()),
          secondRowMergeCells: "A2:G2",
          secondRowText: `थोक पशु वस्तुओं इनपुट रिपोर्ट`,
          fourthRowMergeCells: "A4:G4",
          fourthRowText:  `भाव दिनांक :- (${sDate} - ${eDate})`,
         
          fromDate: payload.fromDate,
          toDate: payload.toDate,
          headerHindiColumns: [
            'क्रम', 'जिला', 'श्रेणी कोड', 'आइटम कोड', 'वस्तु का नाम', 'श्रेणी नाम','औसत  भाव (रू0 में)'
          ],
          
        };
       
     const transformedData = generalMiningReportData.map((item, index)  => [
           index+1,
          item.districtName,
          item.categoryCode,
          item.itemCode,
          item.itemName,
          item.categoryName,
          item.Price   
        ]);
 

        excelObjectData.excelRowData = transformedData;
        generateAnimalProductInputReport(excelObjectData);
         showLoading(false);
      })
      .catch((error) => {
        // Handle error if needed
        console.error('API Error:', error);
        showLoading(false);
      });
  };



  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                     <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.ANIMAL_PRODUCT_INPUT_REPORT : priceTitle.en.ANIMAL_PRODUCT_INPUT_REPORT }} />
              
                    </h4>
                    <div className="row align-items-center">
                        {isDivision && (
                            <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                <label>{storedLanguage === 'hi' ? titlesData.hi.DIVISION : titlesData.en.DIVISION}</label>
                                <input type="text" className="form-control" disabled value={decode_token.id.LOCATION_NAME} />
                            </div>
                        )}

                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">From Date</label>
                            <DatePicker
                                className="form-control calendar_icon"
                                selected={startDate}
                                onChange={(e) => { setStartDate(e) }}
                                dateFormat="MMM yyyy"
                                showMonthYearPicker
                                placeholderText="Select month"
                                maxDate={today}
                            />
                        </div>


                        <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                            <label className="fw-bold h6">To Date</label>
                            <DatePicker
                                className="form-control calendar_icon"
                                selected={endDate}
                                onChange={(e) => { setEndDate(e) }}
                                dateFormat="MMM yyyy"
                                showMonthYearPicker
                                placeholderText="Select month"
                                maxDate={today}
                            />
                        </div>


                        <div className="col-xl-2 col-lg-4 mb-3">
                            <label className="w-100 d-none d-sm-block">&nbsp;</label>
                            <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
   </>
  )
}

export default AnimalProductInputReport